import { AgencyListItem } from "../../../integrated-client/models/";
import { AgencyListItemUI } from "../../../layout/ModalWindows/ModalWindowWrappers/AgencyAndAgencyGroupModal";

export type AgenciesList = Array<AgencyListItem>;
export type AgenciesListUI = Array<AgencyListItemUI>;

export class ResultsData {
  items: AgenciesList;
  showMore: boolean;
  allItems: AgenciesListUI;

  constructor() {
    this.items = [];
    this.showMore = false;
    this.allItems = [];
  }
}
